import {
  addDoc,
  deleteDoc,
  getDocs,
  where,
  query,
  serverTimestamp,
  updateDoc,
  arrayUnion,
  setDoc,
} from "firebase/firestore";
import {
  getPackagePriceRef,
  getPackageRef,
  getPackagesPriceCollectionRef,
  getVouchersCollectionRef,
} from "../../../firebase/collectionReferences";

export async function deletePrice(price_id) {
  const priceRef = getPackagePriceRef(price_id);
  await deleteDoc(priceRef);
}

export async function addPrice(data) {
  const priceRef = getPackagesPriceCollectionRef();
  const price = await addDoc(priceRef, {
    ...data,
    createdAt: serverTimestamp(),
  });
  const packageRef = getPackageRef(data?.package_id);
  await setDoc(
    packageRef,
    {
      price_ids: arrayUnion(price?.id),
      stripe_price_ids: arrayUnion(data?.stripe_price_id),
    },
    { merge: true }
  );
  return price.id;
}

export async function updatePackagePrice(data) {
  const priceRef = getPackagePriceRef(data.id);
  await updateDoc(priceRef, data);
  return data.id;
}

export const getPackagePriceByField = async (key, value) => {
  const priceRef = getPackagesPriceCollectionRef();
  const priceQuery = query(priceRef, where(key, "==", value));
  const priceDocs = (await getDocs(priceQuery)).docs.map((row) => ({
    ...row.data(),
    id: row.id,
  }));

  if (priceDocs.length === 1) {
    return priceDocs[0];
  } else {
    return {};
  }
};

// Get All Prices
export async function getAllPrices() {
  const priceRef = getPackagesPriceCollectionRef();
  const snapshot = await getDocs(priceRef);
  const prices = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
  return prices;
}

// Generate a unique voucher code in format XXXXX-XXXXX-XXXXX
function generateVoucherCode() {
  // Characters allowed in voucher code
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

  // Helper to generate one segment of 5 characters
  function generateSegment(length = 5) {
    let segment = "";
    for (let i = 0; i < length; i++) {
      segment += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return segment;
  }

  // Set to track unique codes
  const generatedCodes = new Set();

  let code;
  do {
    const part1 = generateSegment();
    const part2 = generateSegment();
    const part3 = generateSegment();
    code = `${part1}-${part2}-${part3}`;
  } while (generatedCodes.has(code));

  generatedCodes.add(code);
  return code;
}

// Create Bulk Vocuhers
export async function createBulkVouchers(data) {
  const obj = {
    ...data,
    expires_at: data.expires_at ? data.expires_at.toISOString() : null,
  };

  const voucherCollectionRef = getVouchersCollectionRef();

  const creationPromises = Array.from(
    { length: data.no_of_vouchers },
    async () => {
      const voucher = {
        price_id: obj.price_id,
        package_id: obj?.package_id,
        product_id: obj?.product_id,
        package_price_name: obj.package_price_name,
        voucher_code: generateVoucherCode(),
        expires_at: obj.expires_at,
        vendor: obj.vendor,
        created_at: new Date().toISOString(),
      };

      return await addDoc(voucherCollectionRef, voucher);
    }
  );

  try {
    const results = await Promise.all(creationPromises);
    console.log(
      "All vouchers created successfully:",
      results.map((doc) => doc.id)
    );
    return results;
  } catch (error) {
    console.error("Error creating vouchers:", error);
    throw error;
  }
}
